import { createAction, props } from '@ngrx/store';
import {
  FilterListsResponse,
  FilterListsResponse2,
  MetaPagination,
  ProfileResponse,
  ProfileResponse2,
} from '../../../api';
import { BasePlanningBoardListPayloadInterface } from '../../modules/planning-board/_interfaces/base-planning-board-list-payload.interface';

// Planning Board list
// Same actions are dispatched by all three tenants. The effect picks the
// right backend service: Business + Medical hit the customer-scoped endpoint
// (GET /customers/{customer}/planning-board), Growth hits the PSP-side
// endpoint (GET /psps/{psp}/planning-board). Backend filters server-side:
// customers see only their active items; PSPs see everything in their branch
// scope. The two responses overlap on the shared profile fields the UI reads
// (firstName/lastName/assignments/contractHours/plannedHours/avatarUrl/id);
// the filters blob field names differ — see `CUSTOMER_PLANNING_BOARD_FILTERS`
// vs `PSP_PLANNING_BOARD_FILTERS` in `_constants/base-planning-board-filters.constant.ts`.
export const loadPlanningBoardList = createAction(
  '[Planning Board] Load planning board list',
  props<{ payload: BasePlanningBoardListPayloadInterface }>()
);
export const setPlanningBoardList = createAction(
  '[Planning Board] Set planning board list',
  props<{ payload: Array<ProfileResponse> | Array<ProfileResponse2> }>()
);
export const setPlanningBoardFiltersAndPagination = createAction(
  '[Planning Board] Set planning board filters and pagination',
  props<{ payload: { pagination: MetaPagination; filters: FilterListsResponse | FilterListsResponse2 | undefined } }>()
);
export const successLoadPlanningBoardList = createAction('[Planning Board] Success load planning board list');
export const errorLoadPlanningBoardList = createAction('[Planning Board] Error load planning board list');

// Reset (tenant switch, route exit, logout — resetStore already handles the last one)
export const resetPlanningBoard = createAction('[Planning Board] Reset');
